
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/others",
      function () {
        return require("private-next-pages/brands/others/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/others"])
      });
    }
  